import type { FC, HTMLProps, ReactNode } from "react";

import * as styles from "./Header.styles";

interface Props extends HTMLProps<HTMLDivElement> {
  children: ReactNode;
}

const Header: FC<Props> = ({ children, ...rest }) => (
  <div css={styles.header} {...rest}>
    {children}
  </div>
);

export { Header };
